import { useEffect } from "react";
import { sendGAEventTrigger } from "@/utils/analytics-trigger";
import { useSeoURLStore } from "@/components/context/seo-lang-store";
import { IOfferzSimilarProducts, IProduct } from "@/types/product";

export const useProductTracking = (
  product: IProduct | null,
  offerzSimilarProducts: IOfferzSimilarProducts[],
) => {
  const { setSeoLinks } = useSeoURLStore();

  useEffect(() => {
    if (!product) return;
    setSeoLinks(product.seo_urls);

    const wasSeen = localStorage.getItem("view-item");

    if (!wasSeen) {
      localStorage.setItem("view-item", "true");

      if (offerzSimilarProducts?.length > 0) {
        sendGAEventTrigger("view_item_list", {
          send_to: `${process.env.NEXT_PUBLIC_GTM_MEASUREMENT_ID}`,
          value: product.name,
          label: "related_products",
        });
      }

      sendGAEventTrigger("view_item", {
        send_to: `${process.env.NEXT_PUBLIC_GTM_MEASUREMENT_ID}`,
        value: product.name,
        category: "product_view",
        label: "product_details_page",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
